import store from "@/store";

import { colorNames, boolToIcons } from "@/libs/rcmTableFieldsFunction";
import { _updateData } from "@/api/esdata";
import { ipValidate } from "@/api/formValidate";
import { getFormOptions } from "@/api/formoptions";
import { removeFromGroup } from "@/api/slb";
import { restartSlbMasterProcess  } from "@/api/slb";

const isAdmin = store.state.userData.privilege == "admin";

export const settingZoneExplain = (parentVue) => {
    return {
        description:
            "<p>The <strong>Slb</strong> is where your client will access from there browser, the closer your slb with your client, the better browsing exprience they will have. If you create Slb manually, it will be marked as <strong>virtual</strong>, so it's recommended to name it recognizable.</p>",
    };
};

export const groupName = (parentVue) => {
    return {
        formRender: "FormInput",
        withForm: false,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            return h("TagList", {
                props: {
                    listData: params.row.groupName,
                    maxShow: "5",
                    title: vm.$i18n.t("slbsetting.groupName"),
                    width: "350",
                },
            });
        },
    };
};
export const serviceIP = (parentVue) => {
    return {
        sectionKey: "essential",
        formTypes: ["createForm", "editForm"],
        validate: [
            {
                validator: (rule, value, callback) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (value) return callback();
                    if (vm.formData.recordType === "A" && !vm.formData.serviceIPv6) {
                        return callback(new Error(vm.$i18n.t("slbsetting.atLeastOneServiceIPRequired")));
                    }
                    if (vm.formData.recordType === "CNAME") {
                        return callback(
                            new Error(`${vm.$i18n.t("slbsetting.serviceIP")}${vm.$i18n.t("rcmtable.validateEmptyText")}`)
                        );
                    }
                    callback();
                },
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!value) return callback();

                    if (vm.formData.recordType == "A") {
                        ipValidate("serviceip", value).then((result) => {
                            if (!result.data.success) {
                                return callback(new Error(result.data.message));
                            }
                            callback();
                        });
                    } else if (vm.formData.recordType == "CNAME") {
                        ipValidate("validCname", value).then((result) => {
                            if (!result.data.success) {
                                return callback(new Error(result.data.message));
                            }
                            callback();
                        });
                    }
                },
                trigger: "blur",
            },
        ],
        // 服務地址（IPv6）未填時，這欄的輸入會影響「至少填一項」的提示，連動重驗另一欄
        watchField: (value, formData) => {
            var vm = parentVue.$refs.rcmTable;
            if (formData.recordType !== "A" || formData.serviceIPv6) return;
            vm.$nextTick(() => {
                if (vm.$refs.form && typeof vm.$refs.form.validateField === "function") {
                    vm.$refs.form.validateField("serviceIPv6");
                }
            });
        },
        // 普通用戶無法調整防禦節點IP
        disabled: () => parentVue.$refs.rcmTable.formData.serviceProvideType == "protect" && !isAdmin,
    };
};
export const isEnabled = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: vm.$i18n.t("rcmtable.confirmChangeStatusText"),
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-slbs", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const connectState = (parentVue) => {
    return {
        render: (h, params) => {
            let connected = parentVue.viewSlotInfo.slbclients.includes(params.row._id);
            var iconType = boolToIcons({
                value: connected,
                falseToDash: false,
            });
            var iconColor = connected ? colorNames.green : colorNames.red;
            return !params.row.isDummySlb
                ? h("Icon", {
                      props: {
                          type: iconType,
                          color: iconColor,
                          size: 24,
                      },
                  })
                : h("div", "");
        },
    };
};

export const edges = (parentVue) => {
    return {
        sectionKey: "essential",
        withForm: true,
        maxItemsCount: 30,
        // 普通用戶無法調整防禦節點edges
        disabled: () => parentVue.$refs.rcmTable.formData.serviceProvideType == "protect" && !isAdmin,
        validate: [
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!vm.formData.edges.length)
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: "You are about to leave EDGE empty, proceed carefully.",
                                width: 40,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    callback();
                },
                trigger: "submit",
            },
        ],
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            return h(
                "div",
                params.row.edges
                    .slice()
                    .sort()
                    .map(function (s) {
                        // 等待搜尋結果回傳才定義
                        if (vm.getEsResult) {
                            var edge = vm.getEsResult.edges.find((e) => e.nodeId == s);
                            let serviceProvideTypeTag = edge && edge.serviceProvideType == "normal" ? "N" : "P";

                            return edge
                                ? h(
                                      "Tag",
                                      {
                                          props: {
                                              color: edge.runningStat,
                                          },
                                      },
                                      `${edge.hostname}(${serviceProvideTypeTag}):${edge.serviceIP}`
                                  )
                                : h("div", ``);
                        }
                    })
            );
        },
        remoteOptions: async (queryParams) => {
            var vm = parentVue.$refs.rcmTable;
            queryParams.slbNodeId = vm.formData.nodeId;
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`/edgenames?${queryString}`);
            return result.data.options;
        },
    };
};

export const hostName = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            const p = h("p", params.row.hostname);

            const physicalTag = h("Tag", {}, "physical");

            const normalTag = h("Tag", {}, "normal");
            const protectTag = h("Tag", {}, "protect");

            const elements = [p];
            elements.push(physicalTag);
            elements.push(params.row.serviceProvideType == "protect" ? protectTag : normalTag);
            return h("span", {}, elements);
        },
        validate: [],
    };
};
export const line = (parentVue) => {
    return {
        withOptionGroup: true,
        remoteOptions: async (queryValue, queryParams) => {
            var vm = parentVue.$refs.rcmTable;
            queryValue = queryValue || "*";
            queryParams.lineName = `*${queryValue}*`;
            if (vm.formData.groupName && vm.formData.groupName.length > 0) {
                queryParams.groupNames = vm.formData.groupName;
            } else {
                queryParams.groupName = "";
            }
            queryParams.optionGrouping = true;
            queryParams.withRecordLineGroups = true;
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`/recordlinenames?${queryString}`);
            return result.data.options;
        },
    };
};

export const action = (parentVue) => {
    return {
        width: 160,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const actionDivArray = [];
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });
            var dropdownItems = [];
            if (store.getters.isInAllGroupView) {
                if (!params.row.slbMasterIsRunning) {
                    dropdownItems.push({
                        value: "restart",
                        title: vm.$t("rcmtable.restartText"),
                        modalTitle: vm.$t("rcmtable.restartText"),
                        modalContent: vm.$t("rcmtable.confirmRestartSlbText"),
                        disabled: vm.isRestartBtnDisabled,
                    });
                }
                dropdownItems.push({
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                    disabled: vm.isDeleteBtnDisabled,
                });
            } else {
                dropdownItems.push({
                    value: "removeFromGroup",
                    title: vm.$i18n.t("slbsetting.removeFromGroup"),
                    modalTitle: vm.$i18n.t("slbsetting.removeFromGroup"),
                    modalContent: vm.$i18n.t("slbsetting.removeFromGroupText"),
                    disabled: vm.isEditBtnDisabled,
                });
            }

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    const restartHandler = () => {
                                        restartSlbMasterProcess({
                                            nodeId: params.row.nodeId,
                                            groupName: params.row.groupName,
                                        });
                                    };
                                    const removeFromGroupHandler = () => {
                                        removeFromGroup({
                                            nodeId: params.row.nodeId,
                                            groupName: vm.$store.state.queryGroupName,
                                        });
                                    };
                                    const deleteHandler = () => {
                                        let deleteItem = Object.assign({}, params.row);
                                        delete deleteItem._index;
                                        delete deleteItem._rowKey;

                                        vm.actionType = "delete";
                                        vm.updateData(vm.esIndex, "delete", deleteItem);
                                    };

                                    const defaultHandler = () => {
                                        currentItem
                                            .apiAction(params.row)
                                            .then((result) => {
                                                vm.$Notice.success({
                                                    title: vm.$i18n.t("global.success"),
                                                    desc: `${result.data.message}`,
                                                });
                                            })
                                            .catch(function (error) {
                                                vm.$Notice.warning({
                                                    title: vm.$i18n.t("global.error"),
                                                    desc: `${error}`,
                                                });
                                            });
                                    };

                                    const actions = {
                                        restart: restartHandler,
                                        delete: deleteHandler,
                                        removeFromGroup: removeFromGroupHandler,
                                    };
                                    const action = actions[value] || defaultHandler;

                                    action();
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );
            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }
            actionDivArray.push(moreBtn);
            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/SlbSetting/fields.js